import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'
/*import asyncValidateSpaces from './asyncValidateSpaces'*/
import {loadCardDataSH as loadAccount } from '../../redux/svractions/shreviewActions'
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

import {CRPCFORM} from '../../constants'
import { Icon } from 'antd'

import '../../css/svformwerror.css'
///Users/sam_b2/Downloads/tm/svctest/frontend-quiz/app/css/svdreact.css
//import 'style-loader!../../css/svdreact.css'
import {  Link } from "react-router-dom"
const React = require('react')

const {connect}  = require("react-redux")
const _ = require('lodash')




const svNotifySavePromise=(
    values
)=>{
            let url= `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
            let data = {
                "id": "addLeft_step"

            }
            data = values
            //data =transformToBA(values)
            let postRq={
                method:'POST',
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(data) 
            }


            return fetch(url, postRq).then((rs)=>{
                console.log('sv got rs promise')
                return rs.json()
            }).catch((e)=>{
                return new Promise.resolve(e)
            })
}

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  
  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.card){
            errors.card= 'Required'
        }
        if(!formData.cvv){
            errors.cvv= 'Required'
        }
        if(!formData.mmexp){
            errors.mmexp= 'Required'
        }
        if(!formData.yyyyexp){
            errors.yyyyexp= 'Required'
        }
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CRPaymentCardFormBus extends React.Component{

    constructor(props){
        super(props)
        this.loadGene = this.loadGene.bind(this)
       
    }
 loadGene(e){
        console.log(e)
    }

   
    ddChange(e){
        let tz_all = null
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(tz_all,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }

    componentWillMount()	{
        console.log('sv--call PaymentData  should needs addressid action load to gtethe formvalues pdForm')
        const {   cr_data_card} = this.props
         console.log('sv-- SJPaymentCard  PaymentData custProfile  from SVWizard+')
      
       
        console.log(cr_data_card)
         console.log('sv--SJPaymentCard dcustProfile from  SVWizrd end')
         if( cr_data_card && (cr_data_card.card.length > 0)){
            console.log('sv--SJPaymentCard dcustProfile from  SVWizrd calls load ')
            console.log(cr_data_card)
            this.props.load(cr_data_card)
         }
        
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
      
   
			
			
	

	}
   
    render(){

let tz_all = [{
    name:'EU Time Zone',
    value:'tz_eu'

  },{
    name:'PST Time Eone',
    value:'tz_pst'
  },{

    name:'CST Time Zone',
    value:'tz_cst'
},{
    name:'EST Time Zone',
    value:'tz_est'
  
  }]
        console.log('sv... SVCDnaStepFormBus')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
        //const { initialValues} = this.props
        const { id, gene} = this.props
        const me = this 
        //me.gene = gene

        console.log(this.props)

        return (
            <div>
               
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="right-sd-content"> <text> Add to your stay </text></p>
        
        <div className="form-group">
                     <label htmlFor="needFlight"> </label>
                     <Field
                    
                    id="needFlight"
                       name="needFlight"
                       type="checkbox"
                       placeholder="id"
                       component="input"
                       className="form-control"
                   />
        </div>
        <div className="add-ib-content">


                <p className="sd-check"><text>I will need a flight for my trip </text></p>
                <p className="sd-desc"><text>Flexible flight options from San Francisco to Orlando starting at
                        $473 round-trip. Finish booking this stay to get flight recommendations that match
                        your selected dates. </text></p>


        </div>
        
        <div className="form-group">
                     <label htmlFor="rentcar"> </label>
           
                     <Field
                    
                    id="rentcar"
                       name="rentcar"
                       type="checkbox"
                       placeholder="id"
                       component="input"
                       className="form-control"
                   />
        </div>
        <div className="add-ib-content">
                <p className="sd-check"><text>I m interested in renting a car </text></p>
                <p className="sd-desc"><text>Make the most of your trip – check out car rental options in your
                        booking confirmation.</text></p>
        </div>

        <div className="form-group">
                     <label htmlFor="bookTaxi"> </label>
            
                     <Field
                    
                    id="bookTaxi"
                       name="bookTaxi"
                       type="checkbox"
                       placeholder="id"
                       component="input"
                       className="form-control"
                   />
        </div>
        <div className="add-ib-content">
                <p className="sd-check"><text>Want  book a taxi or shuttle ride in advance?</text></p>
               
        </div>


        </div>

</div>
<div className="rev-row">
             <div className="card card--raised with-shadow">
                 <p className="right-sd-content"> <text> Special requests </text></p>
                 <p className="sd-check"> <text>Special requests can't be guaranteed, but the property will do its best to
                meet your needs. You can always make a special request after your booking is complete.</text>
                </p>
                <div className="form-group">
                     <label htmlFor="card">  Special Requests</label>
                    <Field
                            id="specialRequests"
                            name="specialRequests"
                            
                            
                            placeholder="Senior citizens and wheel chair"
                            component="textarea"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="privateparking"> </label>
                     <Field
                    
                    id="privateparking"
                       name="privateparking"
                       type="checkbox"
                       placeholder="id"
                       component="input"
                       className="form-control"
                   />
                </div>
                <div className="add-ib-content">
                    <p className="sd-check"><text>I would like free private parking on site</text></p>
               
                 </div>
                
            </div>

</div>
<div className="rev-row">
                <div className="card card--raised with-shadow">

                    <p className="right-sd-content"> <text> Your arrival time </text></p>

                    <p className="sd-check">  <span style={{fontSize: "14px"}} > <Icon  style={{ color: 'rgb(176, 35, 211)' }} type="fund" theme="filled" /><text  style={{paddingLeft:'6px'}}>Our Room will be ready for check-in at 3:00 PM</text></span></p>
                    <p className="sd-check">  <span style={{fontSize: "14px"}} > <Icon  style={{ color: 'rgb(209, 107, 24)' }} type="clock-circle" theme="filled" /><text  style={{paddingLeft:'6px'}}>24-hour front desk – help whenever you need it!</text></span></p>
                    <p className="sd-check">  <span style={{fontSize: "14px"}} > <Icon  style={{ color: 'rgb(27, 24, 209)' }} type="snippets" theme="filled" /><text  style={{paddingLeft:'6px'}}>Time Is For Orlando Time Zone</text></span></p>
        
                    
                  

                    <div class="form-group">
                            
                            <label htmlFor="arrivalTimeZone"> </label>
                            <Field id="arrivalTimeZone"  name="arrivalTimeZone" onChange={me.ddChange} component="select">

                                <option  value="">Select Arrival Time Zone</option>
                                {
                                    tz_all.map ((o, idx)=>{

                                        return ( <option  value={o.value}>{o.name}</option>)
                                    })
                                }

                            </Field>

                    </div>

</div>

    </div>
            <div className="form-group">
                     <label htmlFor="id"> ID</label>
                    
                        <Field
                    
                         id="id"
                            name="id"
                            type="text"
                            placeholder="id"
                            component="input"
                            className="form-control"
                        />
                    

                </div>
           
               
                <div className="form-group">
                     <label htmlFor="card">  Credit Card Number</label>
                    <Field
                            id="card"
                            name="card"
                            type="text"
                            placeholder="1234123412341234"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gene">  Card CVV/CVV2</label>
                    <Field
                            id="cvv"
                            name="cvv"
                            type="text"
                            placeholder="123"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="mmexp">  Card Expiration Date Month</label>
                    <Field
                            id="mmexp"
                            name="mmexp"
                            type="text"
                            placeholder="02"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="yyyyexp">  Card Expiration Date Year</label>
                    <Field
                            id="yyyyexp"
                            name="yyyyexp"
                            type="text"
                            placeholder="24"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                

                

               <div>
               <button type="button" className="btn btn-success" onClick={this.props.previousPage}>
          Previous - Space Details
        </button>
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
           Next -  Reservation Confirmation Code
        </button>   
        <span style={{fontSize: "18px", paddingLeft:'10px'}} > <Icon  style={{ color: 'rgb(134, 22, 101)' }} type="carry-out" theme="filled" /><text style={{ color:'rgb(175, 76, 30)', fontWeight:"300",paddingLeft: "8px"}}>We Price Matchsv</text></span>
         </div>
               

               

            </form>
         </div>
        )
    }

}

let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }

const crpcForm = reduxForm({

    form:CRPCFORM,
    validate:validate,
   /* asyncValidate: asyncValidateSpaces,*/
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CRPaymentCardFormBus)

const selector = formValueSelector(CRPCFORM)


let SJPaymentCardFormBusCom =connect((state=>{

    let plucked = state.movies
    let cr_data_card = state.sjreviewView.cr_data_card 
    let o = {initialValues:plucked.sjcpcData, "cr_data_card":cr_data_card }
    selector(state, 'id')
    console.log('sv info')
    console.log(o)
    return o
}),{
   // load:loadPcAction,
   load:loadAccount,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(crpcForm)





export default SJPaymentCardFormBusCom